import { createFeatureSelector } from '@ngrx/store';
import { EnrollmentState } from './enrollment.reducer';

export const getEnrollmentFeatureState =
  createFeatureSelector<EnrollmentState>('enrollment');
